export function showModal(id, index) {
    this.id = id;
    this.index = index;
    this.modalConfig.show = true;
}

export function closeModal(after) {
    this[after]()

    this.modalConfig.title = ''
    this.modalConfig.text = ''
    this.after = 'deleteRate'

    this.modalConfig.show = false;
}



// WEBPACK FOOTER //
// ./src/components/Modal/ModalHelpers.js